// Me Quran cannot draw every Quranic spelling of a long alef.
// Keep this in step with replaceUnsupportedQuranMarks in quranApi.js.

export function normalizeMeQuranArabic(text) {
  return String(text || "")
    .replace(/\u0649([\u064B-\u065F\u06D6-\u06ED]*)\u0670/g, "\u0627$1")
    .replace(/\u066E/g, "");
}
